import Typography from "@insite/mobius/Typography";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import React from "react";

const PageTypeLink = getWidgetComponent("Basic/PageTypeLink");

interface OwnProps {
    title: string;
    invoiceNumber: string;
    isLink?: boolean;
    target?: string;
}

type Props = OwnProps;

const StoreInvoiceDetailPageTypeLink: React.FunctionComponent<Props> = ({ title, invoiceNumber, isLink, target = "_blank" }) => {
    const pageTypeLinkProps = {
        isLink,
        target,
        fields: {
            pageType: "InvoiceDetailsPage",
            overrideTitle: title,
            queryString: `invoiceNumber=${invoiceNumber}`,
        },
    };

    return (
            isLink ? (
                <PageTypeLink {...pageTypeLinkProps} />
            ) : (
                <Typography>{title}</Typography>
            )
        )
};

export default StoreInvoiceDetailPageTypeLink;
